var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFileImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 76.5L28.6667 58.3333L40.3333 68.3333L58.6667 43.3333L70.1667 56.4762V23.3333H50.3333V3.5H10.5V76.5ZM9 0H53.6667L63.6667 10L73.6667 20V78C73.6667 79.1046 72.7712 80 71.6667 80H9C7.89543 80 7 79.1046 7 78V2C7 0.895429 7.89543 0 9 0ZM33.6667 38.3333C33.6667 41.0948 31.4281 43.3333 28.6667 43.3333C25.9052 43.3333 23.6667 41.0948 23.6667 38.3333C23.6667 35.5719 25.9052 33.3333 28.6667 33.3333C31.4281 33.3333 33.6667 35.5719 33.6667 38.3333Z",
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileImg);
export default __webpack_public_path__ + "static/media/icon_file_img.0f2d82a7cfadbd54b7878eda42abf7dd.svg";
export { ForwardRef as ReactComponent };